import React, { useEffect, useState } from "react";
import NavbarWhite from "../components/NavbarWhite";
import Footer from "../components/Footer";
import axios from "axios";

const SuccessAbbonamentoPage = () => {
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const alreadySaved = sessionStorage.getItem("abbonamentoSaved");
    const latest = JSON.parse(localStorage.getItem("latestAbbonamento"));
    const session_id = new URLSearchParams(window.location.search).get("session_id");

    if (!alreadySaved && latest && session_id) {
      const payload = {
        ...latest,
        session_id, // 🆕 attach session_id to avoid duplicates
      };

      axios
        .post("https://api.lidodavittorio.it/api/save-abbonamento", payload)
        .then(() => {
          setSuccess(true);
          sessionStorage.setItem("abbonamentoSaved", "true");
          localStorage.removeItem("latestAbbonamento");
        })
        .catch((err) => {
          console.error("Errore salvataggio abbonamento:", err);
        });
    } else {
      setSuccess(true);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white text-black font-[chivo]">
      <NavbarWhite />
      <div className="pt-32 text-center px-6 max-w-2xl mx-auto">
        {success ? (
          <>
            <h1 className="text-4xl font-bold text-[#009FB7] mb-6">Pagamento completato ✅</h1>
            <p className="text-lg">Grazie per il tuo acquisto! Riceverai una conferma via email.</p>
          </>
        ) : (
          <p className="text-lg text-gray-600">Verifica del pagamento in corso...</p>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default SuccessAbbonamentoPage;
